import { API_PRESCRIPTION } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function getPharmacies(params) {
  return {
    types: [
      ACTION_TYPES.PHARMACY_GET_REQUESTED,
      ACTION_TYPES.PHARMACY_GET_SUCCEED,
      ACTION_TYPES.PHARMACY_GET_FAILED,
    ],
    promise: client => client.get('/pharmacies', { params }),
    options: {
      clientName: API_PRESCRIPTION,
    },
  };
}
